import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _Form from "@hzero-front-ui/hzero-ui/lib/Form";
var _excluded = ["popconfirm", "progress", "steps", "tabs", "spin"];
import React from 'react';
import { ConfigStepContainer, StyledConfigRow } from './index.style';
import TimeLineConfig from '../ComponentsConfig/TimeLineConfig';
import TabConfig from '../ComponentsConfig/TabConfig';
import TableConfig from '../ComponentsConfig/TableConfig';
import PopconfirmConfig from '../ComponentsConfig/PopconfirmConfig';
import ProgressConfig from '../ComponentsConfig/ProgressConfig';
import StepsConfig from '../ComponentsConfig/StepConfig';
import LoadingConfig from '../ComponentsConfig/LoadingConfig';
import AnchorConfig from '../ComponentsConfig/AnchorConfig';
var ConfigStepFour = function ConfigStepFour(_ref) {
  var form = _ref.form,
    config = _ref.config;
  var getFieldDecorator = form.getFieldDecorator;
  return /*#__PURE__*/React.createElement(ConfigStepContainer, null, /*#__PURE__*/React.createElement(StyledConfigRow, null, getFieldDecorator('timeline', {
    initialValue: config.timeline
  })( /*#__PURE__*/React.createElement(TimeLineConfig, null))), /*#__PURE__*/React.createElement(StyledConfigRow, null, getFieldDecorator('anchor', {
    initialValue: config.anchor
  })( /*#__PURE__*/React.createElement(AnchorConfig, null))), /*#__PURE__*/React.createElement(StyledConfigRow, null, getFieldDecorator('tabs', {
    initialValue: {
      tabs: config.tabs,
      tabsCard: config.tabsCard
    }
  })( /*#__PURE__*/React.createElement(TabConfig, null))), /*#__PURE__*/React.createElement(StyledConfigRow, null, getFieldDecorator('table', {
    initialValue: config.table
  })( /*#__PURE__*/React.createElement(TableConfig, null))), /*#__PURE__*/React.createElement(StyledConfigRow, null, getFieldDecorator('popconfirm', {
    initialValue: {
      popconfirm: config.popconfirm,
      modal: config.modal
    }
  })( /*#__PURE__*/React.createElement(PopconfirmConfig, null))), getFieldDecorator('progress', {
    initialValue: {
      lineProgress: config.lineProgress,
      circleProgress: config.circleProgress
    }
  })( /*#__PURE__*/React.createElement(ProgressConfig, null)), /*#__PURE__*/React.createElement(StyledConfigRow, null, getFieldDecorator('steps', {
    initialValue: {
      steps: config.steps,
      stepsGroup: config.stepsGroup
    }
  })( /*#__PURE__*/React.createElement(StepsConfig, null))), /*#__PURE__*/React.createElement(StyledConfigRow, null, getFieldDecorator('spin', {
    initialValue: {
      spin: config.spin,
      collapse: config.collapse
    }
  })( /*#__PURE__*/React.createElement(LoadingConfig, null))));
};
export default _Form.create({
  onValuesChange: function onValuesChange(props, field, values) {
    if (props.onChange) {
      var popconfirm = values.popconfirm,
        progress = values.progress,
        steps = values.steps,
        tabs = values.tabs,
        spin = values.spin,
        rest = _objectWithoutProperties(values, _excluded);
      props.onChange(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, rest), popconfirm), progress), tabs), spin), steps));
    }
  }
})(ConfigStepFour);